import React, { useRef, useEffect } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Form, Icon, Input, Button, Alert } from 'antd'

const PASSWORD_NOT_MATCH_MSG = 'Confirm new password does not match'

const PasswordUpdate = ({
  style,
  className,
  onUpdate,
  errorMessage,
  loading,
  initialUser,
  initialPassword,
  ...props
}) => {
  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFields((err, values) => {
      if (!err) {
        onUpdate && onUpdate(values)
      }
    })
  }
  const newPassRef = useRef()

  useEffect(() => {
    if (newPassRef.current != null && newPassRef.current.input != null) {
      newPassRef.current.input.focus()
    }
  }, [])

  const { getFieldDecorator, getFieldValue, validateFields } = props.form

  const validateToNextPassword = (rule, value, callback) => {
    if (value) {
      validateFields(['newPasswordConfirm'], { force: true })
      callback()
    }
    callback()
  }

  const compareToFirstPassword = (rule, value, callback) => {
    if (value !== getFieldValue('newPassword')) {
      callback(PASSWORD_NOT_MATCH_MSG)
    } else {
      callback()
    }
  }

  return (
    <Form
      onSubmit={handleSubmit}
      className={className}
      css={{ width: '350px', minWidth: '350px', maxWidth: '350px', ...style }}
    >
      <div>Change Password</div>
      <Form.Item>
        {getFieldDecorator('username', {
          rules: [{ required: true, message: 'Please enter your user name' }],
          initialValue: initialUser,
        })(
          <Input
            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="User Name"
          />
        )}
      </Form.Item>
      <Form.Item>
        {getFieldDecorator('existingPassword', {
          rules: [
            { required: true, message: 'Please enter your existing password' },
          ],
          initialValue: initialPassword,
        })(
          <Input
            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
            type="password"
            placeholder="Password"
          />
        )}
      </Form.Item>

      <Form.Item>
        {getFieldDecorator('newPassword', {
          rules: [
            { required: true, message: 'Please enter your new password' },
            { validator: validateToNextPassword },
          ],
        })(
          <Input
            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
            type="password"
            placeholder="New Password"
            ref={newPassRef}
          />
        )}
      </Form.Item>

      <Form.Item>
        {getFieldDecorator('newPasswordConfirm', {
          rules: [{ validator: compareToFirstPassword }],
        })(
          <Input
            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
            type="password"
            placeholder="Confirm New Password"
          />
        )}
      </Form.Item>

      <Form.Item>
        {/*
        {getFieldDecorator('remember', {
          valuePropName: 'checked',
          initialValue: true,
        })(<Checkbox>Remember me</Checkbox>)}
        <a className="login-form-forgot" css={{ float: 'right' }} href="">
          Forgot password
        </a>
        */}
        {errorMessage && <Alert message={errorMessage} type="error" />}
        <Button
          type="primary"
          htmlType="submit"
          css={{ width: '100%' }}
          loading={loading}
        >
          Update Password
        </Button>
        {/*  Or <a href="">register now!</a> */}
      </Form.Item>
    </Form>
  )
}

export default Form.create({ name: 'password_reset' })(PasswordUpdate)
